import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

// Configure emotion cache with optimized settings
export const createEmotionCache = () => {
  return createCache({
    key: 'psa-counselor',
    prepend: true, // Ensures emotion styles are injected first
    speedy: process.env.NODE_ENV === 'production', // Enable optimization in production
    stylisPlugins: [
      prefixer // Adds vendor prefixes automatically
    ]
  });
};